var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Badge = function Badge(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.402 7.614 12.52 4.218a1.04 1.04 0 0 0-1.04 0L5.598 7.614a1.04 1.04 0 0 0-.52.9v6.792c0 .371.199.714.52.9l5.882 3.396a1.04 1.04 0 0 0 1.04 0l5.882-3.396c.322-.186.52-.529.52-.9V8.514a1.04 1.04 0 0 0-.52-.9Zm-4.843-5.196a3.118 3.118 0 0 0-3.118 0L4.56 5.814A3.118 3.118 0 0 0 3 8.514v6.792c0 1.114.594 2.143 1.559 2.7l5.882 3.396a3.118 3.118 0 0 0 3.118 0l5.882-3.396a3.118 3.118 0 0 0 1.559-2.7V8.514a3.118 3.118 0 0 0-1.559-2.7L13.56 2.418Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M11.111 9.075c.28-.861 1.5-.861 1.78 0l.42 1.297h1.364c.906 0 1.282 1.16.55 1.692l-1.104.801.422 1.297c.28.861-.707 1.578-1.44 1.045l-1.102-.8-1.103.8c-.733.533-1.72-.184-1.44-1.045l.422-1.297-1.103-.801c-.733-.533-.357-1.692.55-1.692h1.363l.421-1.297Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Badge;